import React from 'react';
import { connect } from 'react-redux';

import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import BasePage from 'apps/auth/components/utils/BasePage';

import EmailModal from './EmailModal';

const EmailNotificationGA = (props) => {
    return (
        <BaseLayout showChat={false}>
            <EmailModal
                icon="mail-lock-80"
                title={props.secondScreenTitle}
                firstButton={props.continueButton}
                secondButton={props.notNowButton}
                showPopup={true}
            />
        </BaseLayout>
    );
};
const mapStateToProps = (state) => ({
    notNowButton: state.messages.pageMessages.notNowButton,
    secondScreenTitle: state.messages.pageMessages.secondScreenTitle,
    continueButton: state.messages.pageMessages.continueButton,
});
export default connect(mapStateToProps)(BasePage(EmailNotificationGA));
